export const validateFilters = ({
  reportType,
  rateTypes,
  invoiceStartDate,
  invoiceEndDate,
  parkingPeriodStartMonth,
  parkingPeriodStartYear,
  parkingPeriodEndMonth,
  parkingPeriodEndYear,
}) => {
  if (!['RATE_REPORT', 'RATE_AMOUNT_REPORT'].includes(reportType)) {
    if (rateTypes.length === 0) {
      throw new Error('A rate type is required for all invoice reports (excluding summary reports)');
    }
  }

  if (reportType !== 'CARRYOVER_REPORT') {
    // we wrap these numerical values in isNaN and parseInt as to
    // prevent zeros being interpreted as falsy/null values
    const startMonthNotSet = isNaN(parseInt(parkingPeriodStartMonth));
    const startYearNotSet = isNaN(parseInt(parkingPeriodStartYear));
    const endMonthNotSet = isNaN(parseInt(parkingPeriodEndMonth));
    const endYearNotSet = isNaN(parseInt(parkingPeriodEndYear));

    if (!invoiceStartDate && (startMonthNotSet || startYearNotSet)) {
      throw new Error('An invoice start date is required if the parking period is not set.');
    }

    if (
      (parkingPeriodStartMonth && startYearNotSet) || (startMonthNotSet && parkingPeriodStartYear)
    ) {
      throw new Error('The parking period start\'s month and year are required together if the invoice start date is defined.');
    }

    if (
      (parkingPeriodEndMonth && endYearNotSet) || (endMonthNotSet && parkingPeriodEndYear)
    ) {
      throw new Error('A parking period end\'s month and year are required together.');
    }

    if ((parkingPeriodStartMonth && parkingPeriodStartYear) && (parkingPeriodEndMonth && parkingPeriodEndYear)) {
      if (parkingPeriodStartYear === parkingPeriodEndYear) {
        if (Number(parkingPeriodStartMonth) > Number(parkingPeriodEndMonth)) { 
          throw new Error(
            'The parking period start\'s month should be before a parking period end\'s month for the same year'
          );
         }
      }

      if (Number(parkingPeriodStartYear) > Number(parkingPeriodEndYear)) { 
        throw new Error(
          'A parking period start\'s year should be before or equal to a parking period end\'s year.'
        );
       }
    }
  } else {
    if (!invoiceStartDate) { 
      throw new Error('An invoice start date is required for a carryover report.');
     }
  }

  if (invoiceStartDate && invoiceEndDate) {
    if (invoiceStartDate > invoiceEndDate) { 
      throw new Error('An invoice\'s end date should be after an invoice\'s start date for all invoice reports.');
     }
  }

  return true;
};
